import { CardProps, ControlledInput } from "@dune/ui";
import { useFormContext } from "react-hook-form";

interface DatesDetailsContainerProps extends CardProps {
	isDisabled?: boolean;
}

const DatesDetailsContainer = ({
	isDisabled = false,
	...cardProps
}: DatesDetailsContainerProps) => {
	const {
		control,
		formState: { errors },
		setValue,
		trigger,
	} = useFormContext();
	return (
		<div
			className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-4 gap-4"
			{...cardProps}
		>
			<div className="flex flex-row gap-4">
				<div className="flex flex-col gap-2 w-full">
					<ControlledInput
						control={control}
						name="startDate"
						label="Le début des travaux est prévu pour le"
						error={errors.startDate?.message?.toString()}
						type="date"
						disabled={isDisabled}
					/>
				</div>
				<div className="flex flex-col gap-2 w-full">
					<ControlledInput
						control={control}
						name="deliveryDate"
						label="et le chantier devrait être réceptionné le"
						error={errors.deliveryDate?.message?.toString()}
						onChange={async (e) => {
							setValue("deliveryDate", e.target.value);
							trigger("startDate");
						}}
						type="date"
						disabled={isDisabled}
					/>
				</div>
			</div>
			<div className="flex flex-row gap-2 w-full">
				<div className="w-full">
					Une déclaration d'ouverture de chantier a été déposée en mairie pour
					un démarrage au
				</div>
				<div className="flex items-center gap-4 w-full">
					<ControlledInput
						control={control}
						name="cityHallStartDate"
						error={errors.cityHallStartDate?.message?.toString()}
						type="date"
						disabled={isDisabled}
					/>
				</div>
			</div>
		</div>
	);
};

export default DatesDetailsContainer;
